module.exports = __webpack_public_path__ + "media/images/savor_logo-624c1d585e100411e8def54aff4b78cf.png";